var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('div',{staticClass:"layout"},[_c('defaultHeader'),_c('appMain'),_c('defaultFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }